import { Extension } from '@tiptap/core'
import { Plugin } from '@tiptap/pm/state'
import { findManualInstructionMatches } from './manual-instruction-mark'

/**
 * Keeps manualInstruction marks applied when placeholder text appears without the mark
 * (e.g. after setContent paths that skip applyCompliancePlaceholderMarks).
 */
export const ManualInstructionPlugin = Extension.create({
  name: 'manualInstructionPlugin',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction(_transactions, _oldState, newState) {
          const markType = newState.schema.marks.manualInstruction
          if (!markType) {
            return null
          }

          const { doc } = newState
          const tr = newState.tr
          let modified = false

          doc.descendants((node, pos) => {
            if (!node.isText || !node.text) {
              return
            }

            for (const manualMatch of findManualInstructionMatches(node.text)) {
              const from = pos + manualMatch.index
              const to = from + manualMatch.length
              if (!newState.doc.rangeHasMark(from, to, markType)) {
                tr.addMark(
                  from,
                  to,
                  markType.create({
                    instruction: manualMatch.instruction,
                  })
                )
                modified = true
              }
            }
          })

          return modified ? tr : null
        },
      }),
    ]
  },
})
